import { Tree } from "antd";
import { assign, filter, flowRight, isEmpty, isFunction, map as _map, reduce, sortBy, forEach } from "lodash";
import React from 'react';
const { Component } = React;
const TreeNode = Tree.TreeNode;
function noop() {
}
export default class TreeHelp {
    static expandTree(props, children, keyName, titleName, disabled, initTitle) {
        // 禁用根节点以外的节点
        // todo extra 根节点显示配置
        return (_map(sortBy(_map(children, item => handleProxy(item, ["sortNo"])), o => o.sortNo), (item, i) => {
            let selectable = true;
            if (isFunction(props.selectable)) {
                selectable = props.selectable(item, keyName);
            }
            return (<TreeNode selectable={selectable} title={initTitle ? initTitle(item, titleName) : item[titleName]} key={item[keyName]} value={item[keyName]} data={item} disabled={props.disabled} disableCheckbox={props.disableCheckbox}>
            {(item.children && !!item.children.length) ? TreeHelp.expandTree(props, item.children, keyName, titleName, disabled, initTitle) : null // 这里要将子元素显示设置为null
            }
          </TreeNode>);
        }));
    }
    static showRootNode(props, keyName, titleName, pkeyName, initTitle) {
        // 根节点数据
        const item = props.tree;
        // 禁用根节点
        let disabled = false;
        const { disabledTreeNodeFn } = props;
        if (disabledTreeNodeFn) {
            disabled = disabledTreeNodeFn(item);
        }
        let selectable = true;
        if (isFunction(props.selectable)) {
            selectable = props.selectable(item, keyName);
        }
        return (<TreeNode selectable={selectable} title={initTitle ? initTitle(item, titleName) : item[titleName]} key={item[keyName]} value={item[keyName]} data={item} disabled={props.disabled} disableCheckbox={props.disableCheckbox}>
        {TreeHelp.expandTree(props, props.tree.children, keyName, titleName, props.disabled, initTitle)}
      </TreeNode>);
    }
    /**
     * 对外暴露构建树方法
     * @param props
     * @param keyName
     * @param titleName
     * @param pkeyName
     * @returns {Array}
     */
    static showTreeNode(props, keyName, titleName, pkeyName, isRoot, initTitle) {
        if (props.tree && !isEmpty(props.tree)) {
            return TreeHelp.showRootNode(props, keyName, titleName, pkeyName, initTitle);
        }
        // else if (props.list) {// TODO: 优化只执行一次
        //   const tree = TreeHelp.buildTree(props.list, keyName, pkeyName, isRoot);
        //   return TreeHelp.expandTree(props, tree, keyName, titleName, props.disabled, initTitle);
        // }
    }
    /**
     * 构建id与子节点children组成的map  todo rename
     * @param tree
     * @param keyName
     * @param preMap
     * @returns {[path: string]: T[]}
     */
    static buildMap(tree, keyName, preMap) {
        let map = preMap || {};
        map[tree[keyName]] = tree.children;
        _map(tree.children, item => {
            // map[item[keyName]] = item.children;
            TreeHelp.buildMap(item, keyName, map);
        });
        return map;
    }
    /**
     * 构建id->T的map结构
     * @param tree
     * @param keyName
     * @param preMap
     * @returns {*|{}}
     */
    static buildIdWithSelfMap(tree, keyName, preMap = {}) {
        let map = preMap || {};
        map[tree[keyName]] = tree;
        _map(tree.children, item => {
            TreeHelp.buildIdWithSelfMap(item, keyName, map);
        });
        return map;
    }
    static buildIdMapByList(list, keyName, preMap = {}) {
        let map = preMap || {};
        _map(list, item => {
            map[item[keyName]] = item;
        });
        return map;
    }
    /**
     *  将除根节点以外的所有节点组成数据返回
     * @param tree
     * @param keyName
     * @returns {Array}
     */
    static getAllChildrenWithoutRoot(tree, keyName) {
        if (isEmpty(tree)) {
            return [];
        }
        return flowRight(_map => reduce(_map, (preResult, item, key) => {
            return item.length ? preResult.concat(item) : preResult;
        }, []), TreeHelp.buildMap)(tree, keyName);
    }
    /**
     * 将Tree结构转换为数组结构（包含根节点)
     * @param tree
     * @param keyName
     * @returns {any[]}
     */
    static treeToList(tree, keyName) {
        if (isEmpty(tree)) {
            return [];
        }
        return flowRight(_list => filter(_list, item => !!item), // 排空
        // 排空
        _map => reduce(_map, (preResult, item, key) => {
            preResult.push(item);
            return preResult;
        }, []), TreeHelp.buildIdWithSelfMap)(tree, keyName);
    }
    // list转tree
    static buildTree(list, keyName, pkeyName, isRoot) {
        const maps = {};
        const rooList = [];
        list.map((item, i) => {
            if (!item[pkeyName] || isRoot(item)) {
                rooList.push(item);
            }
            else {
                let cList = maps[item[pkeyName]];
                if (!cList) {
                    maps[item[pkeyName]] = cList = [];
                }
                cList.push(item);
            }
        });
        const tree = TreeHelp.mapToTree(rooList, maps, keyName);
        return tree;
    }
    static mapToTree(list, maps, keyName) {
        const tree = [];
        list.map((item, i) => {
            const nItem = assign({}, item);
            tree.push(nItem);
            const children = maps[item[keyName]];
            if (children)
                nItem.children = TreeHelp.mapToTree(children, maps, keyName);
        });
        return tree; //
    }
    static rootListToTree(list, maps, keyName, childKey = "children") {
        const tree = [];
        console.log(158, list)
        forEach(list, (item, i) => {
            const nItem = assign({}, item);
            tree.push(nItem);
            const children = maps[item[keyName]];
            if (children)
                nItem[childKey] = TreeHelp.rootListToTree(children, maps, keyName, childKey);
        });
        return tree;
    }
}
/**
 * 用途：处理props中空值默认为null，无法处理解构赋值的情况
 * @param props
 * @returns {Proxy}
 */
function handleProxy(props, keyList = []) {
    // 不支持Proxy的浏览器，比如IE11
    try {
        return new Proxy(props, {
            get(target, key) {
                // 这里不用显示转换与隐式转换，是因为可能存在空格字符串的情况
                if (keyList.indexOf(key) > -1 && target[key] === null || target[key] === undefined || target[key] === "") {
                    return 0;
                }
                else {
                    return target[key];
                }
            }
        });
    }
    catch (e) {
        let someObj = {};
        Object.keys(props).forEach(function (key) {
            if (keyList.indexOf(key) > -1 && props[key] === null || props[key] === undefined || props[key] === "") {
                someObj[key] = 0;
            }
            else {
                someObj[key] = props[key];
            }
        });
        return someObj;
    }
}



// WEBPACK FOOTER //
// ./src/utils/TreeHelp.jsx